import { LoginPage } from "@/pages/LoginPage";

export function LoginRouteComponent() {
  return <LoginPage />;
}
